export const globalMethods = {
  methods: {
    getTypeColor (type) {
      switch (type) {
        case 'SWEET':
          return 'is-success'
        case 'SAVORY':
          return 'is-danger'
        case 'MISCELLANEOUS':
          return 'is-dark'
        case 'ACCESSORY':
          return 'is-warning'
        case 'SOFT_DRINK':
          return 'is-info'
        case 'ALCOHOL':
          return 'is-primary'
        default:
          return 'is-dark'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/mixins.js